import * as React from 'react'

import {
  IconProps,
  resolveSize,
} from '~/client/src/shared/components/icons/Icon'

export const CompassIcon: React.FC<IconProps> = ({ size = 'md', ...rest }) => {
  const resolved = resolveSize(size)
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={resolved}
      height={resolved}
      viewBox="0 0 40 40"
      fill="none"
      aria-hidden="true"
      {...rest}
    >
      <path d="M20.0001 6.4L24.157 19.6H15.8431L20.0001 6.4Z" fill="#D80A07" />
      <path
        d="M19.9998 32.8L24.1567 19.6H15.8429L19.9998 32.8Z"
        fill="#62626C"
      />
      <path
        d="M7.80352 13.1795C6.10088 16.3417 5.63732 20.0243 6.50176 23.5096L8.1668 22.5506L8.17168 28.284L3.2 25.4139L5.06036 24.3406L4.95586 23.9246C3.98598 20.0451 4.49955 15.9427 6.39532 12.4217L7.80352 13.1795Z"
        fill="#62626C"
      />
      <path
        d="M32.1965 13.1795C33.8992 16.3417 34.3627 20.0243 33.4983 23.5096L31.8333 22.5506L31.8284 28.284L36.8001 25.4139L34.9397 24.3406L35.0442 23.9246C36.0141 20.0451 35.5005 15.9427 33.6047 12.4217L32.1965 13.1795Z"
        fill="#62626C"
      />
    </svg>
  )
}
